import React from 'react'
import { LoadingSpinnerWrapper } from './styles'

type Props = {
  style?: object
  label?: string
}

const LoadingSpinner: React.FC<Props> = (): JSX.Element => {
  return (
    <LoadingSpinnerWrapper className="loading-spinner">
      <div className="base" />
    </LoadingSpinnerWrapper>
  )
}

export default LoadingSpinner
